import React from "react";
import {CaptionStepComponent, FullCaptionComponent} from "../../../../../app/components/caption/CaptionComponent";
import {CodeComponent} from "../../../../../app/components/code/CodeComponent";

export function HashSetInsert1FullCaption() {
    return (<FullCaptionComponent title="VALUE: 1">
        <HashSetInsert11/>
        <HashSetInsert12/>
        <HashSetInsert13/>
        <HashSetInsert14/>
        <HashSetInsert15/>
    </FullCaptionComponent>)
}

export function HashSetInsert11() {
    return (<CaptionStepComponent
        title={<h6>1. Check if our <CodeComponent className="codeValue">VALUE</CodeComponent> is
            unique. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>HashSets only contain unique <CodeComponent className="codeValue">VALUES</CodeComponent>. We should first
            call our <CodeComponent>contains</CodeComponent> function to make sure we don't already have a 1 in our
            HashSet. In this case, we do not already have a 1, so we are good to continue.</p>
    </CaptionStepComponent>)
}

export function HashSetInsert12() {
    const generateHashFunction = "fun generateHash(value: Int): Int {return value % arraySize}"
    return (<CaptionStepComponent title={<h6>2. Generate <CodeComponent
        className="codeHash">HASH</CodeComponent>. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Assuming our hash function is <CodeComponent>{generateHashFunction}</CodeComponent>, if we input 1, we output
            a <CodeComponent className="codeHash">HASH</CodeComponent> of 1.</p>
    </CaptionStepComponent>)
}

export function HashSetInsert13() {
    return (<CaptionStepComponent title={<h6>3. Find sub-collection at the <CodeComponent
        className="codeHash">HASH</CodeComponent> index. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Because our <CodeComponent className="codeHash">HASH</CodeComponent> is 1, we now want to find the
            sub-collection at index 1 of our array. Even though originally inputting 9 into our HashSet gave us an index
            of 1, because we had to <CodeComponent className="codeHash">REHASH</CodeComponent> our HashSet,
            our <CodeComponent className="codeValue">VALUE</CodeComponent> of 9 got a new <CodeComponent
                className="codeHash">HASH</CodeComponent> index of 9. So, we see there is no collision to worry about,
            as there are no items located at index 1 currently.</p>
    </CaptionStepComponent>)
}

export function HashSetInsert14() {
    return (<CaptionStepComponent
        title={<h6>4. Insert <CodeComponent className="codeValue">VALUE</CodeComponent> into the
            sub-collection. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Next, we insert our <CodeComponent className="codeValue">VALUE</CodeComponent> of 1 into the sub-collection
            we found at index 1.</p>
    </CaptionStepComponent>)
}

export function HashSetInsert15() {
    return (<CaptionStepComponent title={<h6>5. If necessary, increase HashSet space to maintain an optimal
        balance. <CodeComponent><s>O(n)</s></CodeComponent> <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Because we only have 5 out of 16 slots, or 31.3% of our slots filled, we do <i>not</i> need to increase our
            space. We skip this step for now.</p>
    </CaptionStepComponent>)
}